import React, {
  FC
} from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import {
  themeColors
} from 'src/shared/utils';
import {
  GraphTick
} from 'src/entities/Graph/ui';

import {
  CustomTooltip
} from '../CustomTooltip';

interface ResultsGraphProps {}

export const testCalibrationQuestions = [
  {
    question: '1',
    result: 10,
    name: 'Which year did the Beatles publish their first album?',
  },
  {
    question: '2',
    result: 30,
    name: 'Which year did the Modern Talking publish their first album?',
  },
  {
    question: '3',
    result: 20,
    name: 'Which year did the Rolling Stones publish their first album?',
  },
  {
    question: '4',
    result: 60,
    name: 'Which year did the Oasis publish their first album?',
  },
  {
    question: '5',
    result: 100,
    name: 'Which year did the Run DMC publish their first album?',
  },
  {
    question: '6',
    result: 90,
    name: 'Which year did the Rammstein publish their first album?',
  },
  {
    question: '7',
    result: 50,
    name: 'Which year did the Doors publish their first album?',
  },
  {
    question: '8',
    result: 88,
    name: 'Which year did the Jacksons 5 publish their first album?',
  },
  {
    question: '9',
    result: 5,
    name: 'Which year did the Coldplay publish their first album?',
  },
  {
    question: '10',
    result: 1,
    name: 'Which year did the Linkin Park publish their first album?',
  },
];

export const ResultsGraph: FC<ResultsGraphProps> = () => {
  return (
    <ResponsiveContainer
      width="100%"
      height={400}
    >
      <BarChart
        data={testCalibrationQuestions}
        barCategoryGap={80}
        barGap={25}
        barSize={40}
        margin={{
          top: 10,
          bottom: 0,
          left: 10,
          right: 10,
        }}
      >
        <CartesianGrid
          stroke={themeColors['gray-whisper']}
          strokeWidth={1}
        />

        <Tooltip
          cursor={false}
          content={<CustomTooltip />}
        />

        <XAxis
          dataKey="question"
          tickMargin={8}
        />

        <Bar
          dataKey="result"
          fill="var(--color-primary)"
          color="var(--color-primary)"
          radius={[12, 12, 4, 4]}
          isAnimationActive={false}
          yAxisId="estimationPercentsAxis"
          unit="%"
        />

        <YAxis
          tickCount={6}
          yAxisId="estimationPercentsAxis"
          orientation="left"
          interval={0}
          tickLine={false}
          axisLine={false}
          width={30}
          tick={<GraphTick textAnchor="end" />}
          type="number"
          domain={[0, 100]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};
